import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
import { Refract } from "./refract";
/**
 * The signature glass surface, mirroring Figma's native Glass effect on the
 * Card component (frost radius 4, refraction 0.8 / depth 100, dispersion 0.5,
 * near-transparent fill).
 *
 * Where Chromium can compose the displacement lens, `Refract` supplies the
 * real refraction and `data-refracting` tightens the rim. Everywhere else the
 * surface carries itself on the frost plus the masked gradient ring — CSS
 * alone cannot refract.
 *
 * Fill and rim come from the `glass-tint-*` utilities in globals.css, which
 * set them as custom properties so a consumer's media query can restyle the
 * surface without having to out-specify an inline style.
 */
const BASE = "relative isolate flex flex-col items-start gap-4 rounded-[var(--radius-2xl)] p-[48px_40px] glass-ring";
/** Chromatic inset pair, standing in for the dispersion at the surface edge. */
const NEUTRAL_SHADOW = "shadow-[0_24px_60px_rgb(49_62_72/0.08),inset_1.5px_1.5px_0.5px_-1px_rgb(255_120_160/0.12),inset_-1.5px_-1.5px_0.5px_-1px_rgb(120_200_255/0.16)]";
const TINTS = {
    neutral: cn("glass-tint-neutral", NEUTRAL_SHADOW),
    blue: cn("glass-tint-blue", NEUTRAL_SHADOW, 
    // The lens already darkens the edge, so the drop shadow pulls back and the
    // insets go white-over-blue.
    "data-refracting:overflow-hidden", "data-refracting:shadow-[0_10px_28px_rgb(49_62_72/0.025),inset_1.5px_1.5px_0.5px_-1px_rgb(255_255_255/0.62),inset_-1.5px_-1.5px_0.5px_-1px_rgb(0_102_172/0.22)]"),
};
/** Standard glass info card (Figma Card component, frost radius 4). */
export const GlassCard = React.forwardRef(({ children, className, style, tint = "neutral", radius = 30, frost = 4, ...props }, forwardedRef) => (_jsx(Refract, { ref: forwardedRef, className: cn(BASE, TINTS[tint], className), frost: frost, radius: radius, style: {
        // Overridden by Refract's own inline backdrop-filter once the lens is
        // live; this is the non-Chromium path.
        backdropFilter: `blur(${frost}px) saturate(1.2)`,
        WebkitBackdropFilter: `blur(${frost}px) saturate(1.2)`,
        ...style,
    }, ...props, children: children })));
GlassCard.displayName = "GlassCard";
//# sourceMappingURL=glass-card.js.map